var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PagerOutlinedIcon from '@juvare/common-web-ui/icons/PagerOutlined';
import FaxOutlinedIcon from '@mui/icons-material/FaxOutlined';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Tooltip } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../hooks';
export const channelIconMap = {
    sms: SmsOutlinedIcon,
    voice: PhoneEnabledOutlinedIcon,
    email: MailOutlineOutlinedIcon,
    push: NotificationsIcon,
    inbox: InboxOutlinedIcon,
    fax: FaxOutlinedIcon,
    pager: PagerOutlinedIcon,
    whatsapp: WhatsAppIcon,
};
export const ChannelIcon = (_a) => {
    var _b;
    var { tooltip, channel } = _a, svgIconProps = __rest(_a, ["tooltip", "channel"]);
    const { t } = useAlertUiTranslation();
    const SvgIconComponent = (_b = channelIconMap[channel]) !== null && _b !== void 0 ? _b : QuestionMarkIcon;
    const label = t(`common.channels.${channel}`);
    const icon = React.createElement(SvgIconComponent, Object.assign({}, svgIconProps, { "aria-label": label }));
    if (tooltip) {
        return React.createElement(Tooltip, { title: label }, icon);
    }
    else {
        return icon;
    }
};
